import { useTranslation } from "react-i18next";
import ModalContainer from "../../../containers/Modal/ModalContainer";
import PropTypes from "prop-types";
import { useState } from "react";

export default function SaveFiltersModal({ selectFilters, save, show, close }) {
  const [filterName, setFilterName] = useState();
  const [errorMessage, setErroMessage] = useState();
  let { t } = useTranslation();

  function saveFilters() {
    if (filterName) {
      save(filterName);
      setFilterName();
    } else {
      setErroMessage(t("required"));
    }
  }

  function clearFilterName() {
    setErroMessage();
    setFilterName();
    close();
  }

  return (
    <ModalContainer
      closeModal={clearFilterName}
      crossmarkAction={clearFilterName}
      cancelButtonTitle={t("Clear")}
      cancelButtonAction={clearFilterName}
      modalTitle={t("Save Filters")}
      submitButtonTitle={t("Done")}
      submitButtonType="submit"
      submitButtonAction={saveFilters}
      isOpen={show}
    >
      <div className="mb-3">
        <div className="label-wrapper">
          <label className="form-label">{t("Filter Name")}</label>
          {errorMessage && <div className="error-msg">{errorMessage}</div>}
        </div>
        <input
          type="text"
          className="form-control"
          onChange={({ target }) => setFilterName(target.value)}
          value={filterName || ""}
          maxLength={20}
        />
      </div>
      <ul className="list-inline  ">
        {selectFilters &&
          selectFilters.map((sel) => (
            <li className="list-inline-item m-2" key={sel.id}>
              <span className="rounded-pill bg-ligth p-2  text-white bg-dark">
                {t(sel.description)}
              </span>
            </li>
          ))}
      </ul>
    </ModalContainer>
  );
}

SaveFiltersModal.propTypes = {
  selectFilters: PropTypes.object.isRequired,
  save: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired,
  close: PropTypes.func.isRequired
};
